import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import U2000InputText from "../../../../../u2000Core/components/formControls/input/U2000InputText";
import type { U2101LogicalUnitPersonalizationHandler } from "./U2101LogicalUnitPersonalizationHandlers";

// Component props interface
interface U2101LogicalUnitPersonalizationDlgProps {
  u2101LogicalUnitPersonalizationHandler: U2101LogicalUnitPersonalizationHandler;
  t: TFunction;
  NS: string;
}

// Dialog component for editing logical unit personalization
function U2101LogicalUnitPersonalizationEditDlg({ u2101LogicalUnitPersonalizationHandler, t, NS }: U2101LogicalUnitPersonalizationDlgProps) {
  const { formStateHandlers } = u2101LogicalUnitPersonalizationHandler;

  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    if (action === "cancel") {
      // Temporarily disable onBlur validation to prevent unwanted validation on cancel
      const originalOnBlur = formStateHandlers.onBlur;
      formStateHandlers.onBlur = () => {
        /* Ignore onBlur during cancel */
      };

      // Close dialog immediately without validation
      u2101LogicalUnitPersonalizationHandler.onDlgClose("cancel");

      // Restore original onBlur handler after dialog closes
      setTimeout(() => {
        formStateHandlers.onBlur = originalOnBlur;
      }, 0);
    } else if (action === "save") {
      // Normal save flow with validation
      u2101LogicalUnitPersonalizationHandler.onDlgClose("save");
    }
  };

  // render
  return (
    <U2000SaveCancelDialog isOpen={u2101LogicalUnitPersonalizationHandler.isDialogOpen} onClose={handleClose} title={t("lblLogicalUnitPersonalization", { ns: NS })} isValid={true}>
      <div className="flex flex-col gap-y-4">
        <div>
          <U2000InputText fieldName="logicalUnitPersonalizationCode" label={t("lblLogicalUnitPersonalizationCode", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
        <div>
          <U2000InputText fieldName="logicalUnitPersonalizationDescription" label={t("lblLogicalUnitPersonalizationDescription", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
        <div>
          <U2000InputText fieldName="logicalUnitPersonalizationValue" label={t("lblLogicalUnitPersonalizationValue", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U2101LogicalUnitPersonalizationEditDlg;
